import { IconDefinition } from "./types";

const pencil: IconDefinition = {
  iconName: "pencil",
  width: 576,
  height: 512,
  svgPathData:
    "M31.1 473.9L16 528c20.7-5.8 87.4-24.5 200-56L526.1 161.9 560 128c-15.6-15.6-52.3-52.3-110.1-110.1L416-16 382.1 17.9 72 328 31.1 473.9zM215 405.1L138.9 329 321 146.9 397.1 223 215 405.1zm-39.5 28.4l-90.3 25.3 25.3-90.3 65 65zM492.1 128L431 189.1 354.9 113 416 51.9 492.1 128z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "pencil",
  unicode: 0xf303,
};

export { pencil };
